import React, { Component } from 'react';
import { Container, Button, Label, Form, FormGroup, Input, FormFeedback, Row, Col, Card, CardBody, CardLink, Modal, ModalHeader, ModalBody } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import TarjetaConvo from '../../Componentes/Cards/convocatoriasCard'
import TarjetaEtapas from '../../Componentes/Cards/etapasConvoCard'
import { toast } from 'react-toastify'
import validaciones from '../../Auxiliares/validaciones'
import SideBar from '../../Img/SideBar.png'

export default class AdminUsuarios extends Component {
    constructor() {
        super();
        this.state = {
            year: '',
            semestre: 0,
            convocatoria: '',
            nombre: '',
            ap_paterno: '',
            ap_materno: '',
            rfc: '',
            rol: 'auxiliar',
            errors: {},
            convocatorias: [],          
            isAddModalOpen: false
        }
        this.toggleAdd = this.toggleAdd.bind(this)
        this.actualizarLista = this.actualizarLista.bind(this)
    }

    componentDidMount() {
        this.actualizarLista();
    }

    actualizarLista() {
        Fetch('/getInscripciones', {
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => {
                this.setState({ convocatorias: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ convocatorias: [] })
                        break;

                    default:
                        break;
                }
            })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;

                case 'ap_paterno':
                    if (validaciones.validar_ap_paterno(this.state.ap_paterno)) {
                        value = validaciones.validar_ap_paterno(this.state.ap_paterno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_paterno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_paterno) });
                    }
                    break;

                case 'ap_materno':
                    if (validaciones.validar_ap_materno(this.state.ap_materno)) {
                        value = validaciones.validar_ap_materno(this.state.ap_materno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_materno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_materno) });
                    }
                    break;

                case 'rfc':
                    if (validaciones.validar_rfc(this.state.rfc)) {
                        value = validaciones.validar_rfc(this.state.rfc)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rfc: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rfc) });
                    }
                    break;

                case 'rol':
                    if (validaciones.validar_rol(this.state.rol)) {
                        value = validaciones.validar_rol(this.state.rol)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rol: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rol) });
                    }
                    break;
                
                default:
                    break;
            }
        })
    }

    setValueNumber(field, ev) {
        this.setState({ [field]: Number(ev.target.value) })
    }

    toggleAdd() {
        this.setState(
            prevState => ({
            isAddModalOpen: !prevState.isAddModalOpen
        }));
        this.setState({
            year: '',
            semestre: '',
            convocatoria: '',
            nombre: '',
            ap_paterno: '',
            ap_materno: '',
            rfc: '',
            rol: 'auxiliar',
            errors: {},
        })
    }

    registrate = () => {
        const { convocatoria } = this.state
    
        //if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/addInscripcion', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ convocatoria })
            }).then(Response => {
                this.actualizarLista();
                this.toggleAdd();
            }).catch(err => {
                switch (err.status) {
                    
                    case 600:
                        toast.error('Error inesperado')
                        break;
    
                    case 601:
                        toast.error('Esta convocatoria ya existe')
                        break;
    
                    case 604:
                        toast.error('Esta convocatoria no pudo ser registrada')
                        break;
    
                    default:
                        break;
                }
            })
        //}
    }

    render() {
        if(this.state.year.toString().length>3 
        && this.state.semestre!=0 
        && this.state.year.toString().match(/^[0-9]+$/)!=null){
        this.state.convocatoria = this.state.year + '-' + this.state.semestre
        }
        else this.state.convocatoria = ''

        var y = new Date()

        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <Card className="mt-3 mb-3 p-4" >
                                        <h1 className="display-4">Convocatorias</h1>
                                        <p className="lead">En este segmento se podrán dar de alta Convocatorias, así como editar las ya existentes</p>
                                        <hr className="my-1" />
                                    </Card>
                                    <Row>
                                        <Col xs="12">
                                            <Button 
                                            className="list-group-item float-right mb-3"
                                            style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}} 
                                            onClick={() => this.toggleAdd()}>Agregar Convocatoria</Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <TarjetaConvo encabezado={true} />
                                        {this.state.convocatorias.length > 0 ? this.state.convocatorias.map((index) => 
                                        (<TarjetaConvo id={index._id} nombre={index.convocatoria} estado={index.activo} etapa={index.etapa} actualizar={this.actualizarLista} />)) : 
                                        <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>}        
                                    </Row>

                                    <Modal isOpen={this.state.isAddModalOpen} toggle={() => this.toggleAdd()}
                                        className="modal-md">
                                        <ModalHeader toggle={() => this.toggleAdd()}>Agregar Convocatoria</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <Card className="p-3 text-center">
                                                        <Form className="register-form" method="post" encType="multipart/form-data" >

                                                            <FormGroup >
                                                                <Label> Año de la Convocatoria</Label>
                                                                <Input className="w-100" type="number" onChange={this.setValue.bind(this, "year")} placeholder="(Sólo números)" name="year" defaultValue={this.state.year} />
                                                                <FormFeedback>{this.state.errors.year}</FormFeedback>
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Label> Periodo de la Convocatoria</Label>
                                                                <Input type="select" name="semestre" onChange={this.setValue.bind(this, "semestre")} className="w-100" defaultValue={this.state.semestre || 0}>
                                                                    <option value={0}>Sin seleccionar</option>
                                                                    <option value={1}>Semestre 1</option>
                                                                    <option value={2}>Semestre 2</option>
                                                                </Input>
                                                                <FormFeedback>{this.state.errors.semestre}</FormFeedback>
                                                            </FormGroup>
                                                        </Form>

                                                        <CardBody>
                                                            {this.state.convocatoria && !(this.state.year < y.getFullYear()) &&
                                                            <Col>
                                                            ¿Crear la convocatoria para el periodo {this.state.convocatoria}?
                                                            </Col>
                                                            }
                                                            {!this.state.convocatoria &&
                                                            <Col>
                                                            Defina un periodo para la convocatoria a crear
                                                            </Col>
                                                            }
                                                            {(this.state.year < y.getFullYear()) && this.state.convocatoria &&
                                                            <Col>
                                                            El año designado ya ha transcurrido, defina uno nuevo
                                                            </Col>
                                                            }
                                                            <CardLink><Button disabled={!this.state.convocatoria || this.state.year < y.getFullYear()} className="btn-info" onClick={() => this.registrate()}>Crear</Button></CardLink>
                                                            <CardLink><Button className="btn-light" onClick={() => this.toggleAdd()}>Cancelar</Button></CardLink>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}
